export const BEFORE_CREATE_ONBOARDING_DASHBOARD_USERNAME = 'BEFORE_CREATE_ONBOARDING_DASHBOARD_USERNAME';
export const CREATE_ONBOARDING_DASHBOARD_USERNAME = 'CREATE_ONBOARDING_DASHBOARD_USERNAME';
export const NETWORK_ERROR_CREATING_ONBOARDING_DASHBOARD_USERNAME = 'NETWORK_ERROR_CREATING_ONBOARDING_DASHBOARD_USERNAME';

export const BEFORE_RESEND_EMAIL_VERIFICATION = 'BEFORE_RESEND_EMAIL_VERIFICATION';
export const RESEND_EMAIL_VERIFICATION = 'RESEND_EMAIL_VERIFICATION';
export const NETWORK_ERROR_RESENDING_EMAIL_VERIFICATION = 'NETWORK_ERROR_RESENDING_EMAIL_VERIFICATION';
